import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Settings = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 48 48"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 43.47a19.44 19.44 0 0 0 9.01 0 1.94 1.94 0 0 0 1.47-1.68l.34-3.07a2.32 2.32 0 0 1 3.25-1.87l2.81 1.23a1.92 1.92 0 0 0 2.2-.45 20.37 20.37 0 0 0 4.51-7.78 1.94 1.94 0 0 0-.7-2.13l-2.49-1.84a2.33 2.33 0 0 1 0-3.77l2.49-1.83a1.94 1.94 0 0 0 .7-2.14c-.9-2.9-2.45-5.55-4.52-7.78a1.94 1.94 0 0 0-2.2-.45l-2.8 1.24c-.29.13-.6.2-.92.2a2.34 2.34 0 0 1-2.32-2.09l-.34-3.06a1.94 1.94 0 0 0-1.5-1.68c-1.47-.33-2.97-.5-4.47-.52-1.52.02-3.02.2-4.5.52a1.93 1.93 0 0 0-1.5 1.68l-.34 3.06a2.35 2.35 0 0 1-3.26 1.9l-2.8-1.24a1.94 1.94 0 0 0-2.2.45 20.35 20.35 0 0 0-4.51 7.78 1.94 1.94 0 0 0 .7 2.13l2.49 1.84a2.34 2.34 0 0 1 0 3.77l-2.5 1.83a1.94 1.94 0 0 0-.7 2.14c.91 2.9 2.45 5.56 4.52 7.78a1.9 1.9 0 0 0 1.41.62c.27 0 .53-.06.78-.16l2.82-1.24a2.34 2.34 0 0 1 3.25 1.88l.34 3.06a1.94 1.94 0 0 0 1.47 1.67ZM24 30.25a6.25 6.25 0 1 1 0-12.5 6.25 6.25 0 0 1 0 12.5Z"
  }));
});
Settings.displayName = 'Settings';
export var SettingsDimensions = {
  height: 48,
  width: 48
};